import aumentar from './images/ampliar.png'
import disminuir from './images/disminuir.png'


export const Section5IconComponent = ({isOpen}) => {
    return (
        isOpen ?
        <img src={disminuir} alt="Cerrar" className=''/>
        :
        <img src={aumentar} alt="Abrir" className=''/>
    )
}